(angular => {

  angular.module("FindRetailerNotBussinesClub", [
      "Config"
    ])

    .config(["$routeProvider", configRouter]);

  function configRouter($routeProvider) {
    $routeProvider
      .when("/findRetailerNotBussinesClub", {
        controller: "FindRetailerNotBussinesClub.IndexCtrl",
        controllerAs: "$ctrl",
        templateUrl: `admin/findRetailerNotBussinesClub/list/list.html`,
        role: ['admin', 'company_manager']
      });
  }

})(angular);
